import React from 'react';

const SvgFi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="FI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="FI_svg__b" fill="#fff">
        <use xlinkHref="#FI_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#0848A6"
        mask="url(#FI_svg__b)"
        d="M-1.333 12H8v9.333h4V12h17.333V8H12v-9.333H8V8h-9.333z"
      />
    </g>
  </svg>
);

export default SvgFi;
